import React from "react";
import Select from "react-select";

const Form = ({ vehiculos, empleados, empleado, solicitud }) => {
    if (!solicitud) {
        solicitud = {};
    }
    return (
        <div className='popup__body'>
            <div className='row form-group'>
                <div className='col col-md-4'>
                    <label className='label form-control-label'>
                        Descripción:
                    </label>
                </div>
                <div className='col col-md-8'>
                    <textarea
                        type='text'
                        name='descripcion'
                        rows='5'
                        className='form-control'
                        defaultValue={solicitud.descripcion}
                    />
                </div>
            </div>
            <div className='row form-group'>
                <div className='col col-md-4'>
                    <label className='label form-control-label'>
                        Vehiculo:
                    </label>
                </div>
                <div className='col col-md-8'>
                    <Select
                        name='vehiculo_id'
                        isClearable={true}
                        defaultValue={
                            solicitud.vehiculoId && {
                                value: solicitud.vehiculoId,
                                label: solicitud.vehiculo
                            }
                        }
                        options={vehiculos.map(vehiculo => ({
                            value: vehiculo.id,
                            label: vehiculo.ficha
                        }))}
                    />
                </div>
            </div>
            <div className='row form-group'>
                <div className='col col-md-4'>
                    <label className='label form-control-label'>
                        Empleado:
                    </label>
                </div>
                <div className='col col-md-8'>
                    <Select
                        name='empleado_id'
                        isClearable={true}
                        defaultValue={
                            solicitud.empleadoId && {
                                isFixed: true,
                                value: solicitud.empleadoId,
                                label: solicitud.empleado
                            }
                        }
                        options={empleados.map(empleado => ({
                            value: empleado.id,
                            label: empleado.nombreCompleto
                        }))}
                    />
                </div>
            </div>
            <div className='row form-group'>
                <div className='col col-md-4'>
                    <label className='label form-control-label'>Estado:</label>
                </div>
                <div className='col col-md-8'>
                    <select
                        type='date'
                        name='estado'
                        className='form-control'
                        defaultValue={solicitud.estado}>
                        <option value='pendiente'>Pendiente</option>
                        <option value='en-progreso'>En Progreso</option>
                        <option value='completada'>Completada</option>
                        <option value='cancelada'>Cancelada</option>
                    </select>
                </div>
            </div>
        </div>
    );
};

export default Form;
